// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2346":"a337e283","2955":"8941ed43","4903":"308b80d0","6737":"449679bd","8095":"8941ed43"}[chunkId] + ".chunk.css";
};